import React from 'react'
import type { PublicProfileCollection } from 'apollo-gql'
import { useTranslation } from 'lib/i18n'

import ProfileCollectionSidescroll from 'components/ProfileCollectionSidescroll/ProfileCollectionSidescroll'
import useTrending from 'hooks/useTrending'

const ProfileCollections: React.FC = () => {
  const {
    trendingCollection = {} as PublicProfileCollection,
    error: trendingError,
    loading: trendingLoading,
  } = useTrending()
  const { t } = useTranslation()
  const isEmptyResult = Object.keys(trendingCollection).length === 0

  if (trendingLoading || trendingError || isEmptyResult) return null

  return (
    <ProfileCollectionSidescroll
      title={t('ProfileCollections.title', 'Popular on memmo')}
      profileCollection={trendingCollection}
      loading={trendingLoading}
    />
  )
}
export default ProfileCollections
